<div class="cartSummary_data_costs">
  <p class="cartSummary_data_costs_item" *ngIf="summary?.subscriptionsPrice">
    {{"cart.summary.subscriptionPrice" | translate}}
    <span class="cartSummary_data_costs_item_price">{{summary?.subscriptionsPrice.formattedValue}}</span>
  </p>
  <p class="cartSummary_data_costs_item" *ngIf="summary?.priceWithoutAdditionalServices">
    {{"cart.summary.withoutInsurances" | translate}}
    <span class="cartSummary_data_costs_item_price">{{summary?.priceWithoutAdditionalServices.formattedValue}}</span>
  </p>
  <p class="cartSummary_data_costs_item" *ngIf="summary?.totalInsurancePrice">
    {{"cart.summary.insurances" | translate}}
    <span class="cartSummary_data_costs_item_price">{{summary?.totalInsurancePrice.formattedValue}}</span>
  </p>
  <p class="cartSummary_data_costs_item" *ngIf="summary?.totalServicesPrice">
    {{"cart.summary.additionals" | translate}}
    <span class="cartSummary_data_costs_item_price">{{summary?.totalServicesPrice.formattedValue}}</span>
  </p>
  <p class="cartSummary_data_costs_item" *ngIf="summary?.totalDiscounts">
    <span *ngIf="isInsuranceCouponApplied; else promotionBlock">
      {{"cart.summary.voucher" | translate}}
    </span>
    <ng-template #promotionBlock>{{"cart.summary.discount" | translate}}</ng-template>
    <span class="cartSummary_data_costs_item_price">{{summary?.totalDiscounts.formattedValue}}</span>
  </p>
  <p class="cartSummary_data_costs_item" *ngIf="summary?.deliveryCost">
    {{"cart.summary.delivery" | translate}}
    <span class="cartSummary_data_costs_item_price">{{summary?.deliveryCost.formattedValue}}</span>
  </p>
  <p class="cartSummary_data_costs_item cartSummary_data_costs_item-important">
    {{"cart.summary.total" | translate}}
    <span class="cartSummary_data_costs_item_price">{{summary?.totalPrice.formattedValue}}</span>
  </p>
  <p class="cartSummary_data_costs_item" *ngIf="summary?.minimalDownpayment && asmMode === 'true'">
    {{"cart.summary.minimalDownpayment" | translate}}
    <span class="cartSummary_data_costs_item_price">{{summary?.minimalDownpayment.formattedValue}}</span>
  </p>
</div>

<div *ngIf="summary?.freeDeliveryLeftAmount" class="cartSummary_data_freeDelivery">
  {{"cart.summary.freeDelivery" | translate}}
  <span class="cartSummary_data_freeDelivery_lack">{{summary?.freeDeliveryLeftAmount.formattedValue}}</span>
</div>
